var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlrCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 242,
    viewBox: "0 0 242 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 241C187.274 241 241 187.274 241 121C241 54.7258 187.274 1 121 1C54.7258 1 1 54.7258 1 121C1 187.274 54.7258 241 121 241Z",
    fill: "url(#paint0_linear_1585_4637)",
    stroke: "url(#paint1_linear_1585_4637)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121 241C187.274 241 241 187.274 241 121C241 54.7258 187.274 1 121 1C54.7258 1 1 54.7258 1 121C1 187.274 54.7258 241 121 241Z",
    fill: "url(#paint2_linear_1585_4637)",
    stroke: "url(#paint3_linear_1585_4637)",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121 226.091C179.041 226.091 226.091 179.041 226.091 121C226.091 62.9601 179.041 15.9092 121 15.9092C62.9601 15.9092 15.9092 62.9601 15.9092 121C15.9092 179.041 62.9601 226.091 121 226.091Z",
    fill: "url(#paint4_linear_1585_4637)",
    stroke: "url(#paint5_linear_1585_4637)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.995 216.17C173.557 216.17 216.168 173.56 216.168 120.998C216.168 68.4358 173.557 25.8257 120.995 25.8257C68.4329 25.8257 25.8228 68.4358 25.8228 120.998C25.8228 173.56 68.4329 216.17 120.995 216.17Z",
    fill: "url(#paint6_linear_1585_4637)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9277 112.734C58.9277 110.449 53.3698 108.596 46.5139 108.596C39.6579 108.596 34.1001 110.449 34.1001 112.734C34.1001 115.019 39.6579 116.872 46.5139 116.872C53.3698 116.872 58.9277 115.019 58.9277 112.734Z",
    fill: "#FFF09F",
    stroke: "#D3AD18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.408 110.644C76.7428 110.644 81.8781 105.508 81.8781 99.1737C81.8781 92.8389 76.7428 87.7036 70.408 87.7036C64.0733 87.7036 58.938 92.8389 58.938 99.1737C58.938 105.508 64.0733 110.644 70.408 110.644Z",
    fill: "#FFF09F",
    stroke: "#D3AD18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.485 116.865C202.341 116.865 207.899 115.013 207.899 112.727C207.899 110.442 202.341 108.589 195.485 108.589C188.629 108.589 183.071 110.442 183.071 112.727C183.071 115.013 188.629 116.865 195.485 116.865Z",
    fill: "#FFF09F",
    stroke: "#D3AD18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.049 99.1737C183.049 105.522 177.905 110.644 171.579 110.644C165.231 110.644 160.109 105.5 160.109 99.1737C160.109 92.8257 165.253 87.7036 171.579 87.7036C177.905 87.7036 183.049 92.8476 183.049 99.1737Z",
    fill: "#FFF09F",
    stroke: "#D3AD18",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.9109,
    y: 125.378,
    width: 140.19,
    height: 32.6034,
    rx: 16.3017,
    fill: "#FFF09F",
    stroke: "url(#paint7_linear_1585_4637)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1585_4637",
    x1: 17.5517,
    y1: 42.3793,
    x2: 216.172,
    y2: 207.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1585_4637",
    x1: 42.3793,
    y1: 21.6897,
    x2: 203.759,
    y2: 220.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477802,
    stopColor: "#8E7134",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1585_4637",
    x1: 17.5517,
    y1: 42.3793,
    x2: 216.172,
    y2: 207.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D19C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1585_4637",
    x1: 5.13793,
    y1: 178.931,
    x2: 232.724,
    y2: 71.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#936D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538735,
    stopColor: "#452F16",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#443D2C",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1585_4637",
    x1: 232.725,
    y1: 174.791,
    x2: 162.38,
    y2: 5.13602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#F1D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#E6B163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1973B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1585_4637",
    x1: 29.9666,
    y1: 38.2395,
    x2: 199.622,
    y2: 195.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1585_4637",
    x1: 200.864,
    y1: 207.413,
    x2: 43.7451,
    y2: 25.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#FCD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1585_4637",
    x1: 121.006,
    y1: 125.128,
    x2: 121.006,
    y2: 158.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2983B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#904E0B",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlrCoin);
export default __webpack_public_path__ + "static/media/BLR_Coin.3890a96a1d20e319d08d17416914b76a.svg";
export { ForwardRef as ReactComponent };